import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import MDBadge from "components/MDBadge";
import Button from "@mui/material/Button";

export default function inquiriesTableData({ inquiryList = [], onView }) {
  return {
    columns: [
      { Header: "Name", accessor: "name", width: "18%", align: "left" },
      { Header: "Email", accessor: "email", align: "left" },
      { Header: "Phone", accessor: "phone", align: "left" },
      { Header: "Message", accessor: "message", width: "30%", align: "left" },
      { Header: "Submitted", accessor: "submittedAt", align: "left" },
      { Header: "Status", accessor: "status", align: "center" },
      { Header: "Actions", accessor: "actions", align: "center" },
    ],

    rows: inquiryList.map((inquiry) => ({
      name: (
        <MDTypography variant="button" fontWeight="medium">
          {inquiry?.name}
        </MDTypography>
      ),
      email: (
        <MDTypography variant="caption" color="text" fontWeight="medium">
          {inquiry?.email}
        </MDTypography>
      ),
      phone: (
        <MDTypography variant="caption" color="text" fontWeight="medium">
          {inquiry?.phone}
        </MDTypography>
      ),
      message: (
        <MDTypography
          variant="caption"
          color="text"
          fontWeight="medium"
          sx={{
            display: "-webkit-box",
            WebkitLineClamp: 2,
            WebkitBoxOrient: "vertical",
            overflow: "hidden",
          }}
        >
          {inquiry?.message}
        </MDTypography>
      ),
      submittedAt: (
        <MDTypography variant="caption" color="text" fontWeight="medium">
          {inquiry?.submittedAt}
        </MDTypography>
      ),
      status: (
        <MDBadge
          badgeContent={inquiry?.status}
          color={inquiry?.status === "closed" ? "success" : "warning"}
          variant="gradient"
          size="sm"
        />
      ),
      actions: (
        <MDBox display="flex" alignItems="center" justifyContent="center" gap={1}>
          <Button size="small" onClick={() => onView(inquiry)}>
            View
          </Button>
        </MDBox>
      ),
    })),
  };
}
